module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "label1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('strong', [_vm._v("1")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("Return Migrants’ Self-Selection")])]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_vm._v("Evidence for Indian Inventors")]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor"
  }, [_vm._v("Stefano Breschi, Francesco Lissoni, and Ernest Miguelez")]), _vm._v(" "), _c('p', {
    staticClass: "h4a",
    attrs: {
      "id": "ch1.1"
    }
  }, [_c('strong', [_vm._v("1.1   Introduction")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Return migration represents an important share of present-day total cross-border population flows. In 2008, the International Migration Outlook of the Organisation for Economic Co-operation and Development (OECD), based on indirect estimation methods, suggested that 20 percent to 50 percent of adult immigrants to advanced countries might leave within five years after their arrival, albeit with much variation due to heterogeneity of sending-receiving country pairs, years of entry, and the definition of “return migrant” itself (OECD 2008)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en1",
      "id": "rch1en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Such high rates also affect high-skilled (highly educated) migrants. Based on a large sample of foreign recipients of a US doctorate in science and engineering, Finn (2014) calculates an average return rate—five years after graduation—of about 30 percent, with country-specific figures ranging from less than 10 percent for India and China to over 40 percent for Western European countries. In addition, evidence from questionnaires on return intentions suggests, for migrants to the United States and Germany, a U-shaped relationship between years of schooling and return rates (Dustmann and Görlach 2016)—that is, a self-selection of return migrants with respect to very low and very high educational levels. OECD (2008) estimates on actual returns conform to this pattern, especially for the United States.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("High-skilled return migration is especially relevant for innovation studies. From the viewpoint of migrants’ home countries, returnee scientists, engineers, and other professionals can play a role in knowledge diffusion and new business creation."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en2",
      "id": "rch1en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" In this respect, high-skill return migration can act as a potential compensating mechanism for the “brain drain” suffered by sending countries (Dustmann, Fadlon, and Weiss 2011; Gibson and Mc Kenzie 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for host countries, their policy-makers, higher education institutions, and knowledge-intensive firms fret not only about attracting but also about retaining the “best and brightest” among foreign workers and students (Hawthorne 2018; Teitelbaum 2014; Wadhwa et al. 2009). This begs the question of whether returnees self-select positively not only with respect to their immediately observable skills, such as educational level, but also with respect to harder-to-observe skills, such as inventiveness, creativity, or entrepreneurial propensity, conditional on education.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More generally, the issue of skill-based self-selection of return migrants plays a crucial role in economic theories of migration as a lifetime investment with important implications for the expected economic and social assimilation of both permanent and temporary migrants (Borjas and Bratsberg 1996; Dustmann and Görlach 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite its relevance, return migration is an understudied topic due to a lack of data. National authorities commonly register the inflows of foreignborn and foreign nationals but not their outflows, which makes it nearly impossible to know precisely how many immigrants later leave the country and when, let alone their individual characteristics. Quantitative research then relies on longitudinal surveys or on complex manipulation of administrative panel data (Dustmann and Görlach 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most surveys, however, concern specific, often low-skilled migrant groups "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("(such as the "), _c('em', [_vm._v("gastarbaiters")]), _vm._v(" of the 1960s and 1970s in the much-used German Socio-economic Panel) and/or focus on labor market determinants of return migration, such as unemployment (Bijwaard, Schluter, and Wahba 2014). Notable but rare exceptions concern academic scientists, whose return rates and individual characteristics can be obtained by combining archival and bibliometric data sources, as in Gaulé (2014) and Kahn and MacGarvie (2016).")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In a recent assessment of the emerging literature on migration and innovation, Kerr (2017) states that we know very little about return migration of workers engaged in innovation and entrepreneurship except that it is rapidly growing in importance and that “clever data work to . . . quantify [it] would be most welcome” (Kerr 2017, 212). This chapter answers the call. Based on an ambitious data-linkage project joining patent data and inventors’ biographical information from a web-based, professionally oriented social network, we build a large sample of US immigrant inventors of Indian origin specializing in the information and communication technologies (ICT) sector. This is a social group that both figures prominently in the recent debate on temporary work migration to the United States (most notably on the use of H-1B visas; Kerr and Lincoln 2010) and contributes significantly to international student mobility (OECD 2017).")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Our data-mining strategy allows us to identify only migrants entering the United States via work and education channels, most likely associated with temporary visas. Yet we do not consider it a weak point due to two wellestablished stylized facts:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1. The overwhelming importance of temporary channels as a source for high-skilled immigration into the United States via the transformation of both temporary work and student visas into permanent ones (in contrast with countries such as Australia and Canada, where permanent visas for the highly skilled are more easily obtained upon entry; Koslowski 2018)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("2. The remarkable innovation impact of migrant scientists and engineers entering the United States with work and student visas, as opposed to those entering through the channel of family reunions, as documented by Hunt (2013)")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("While subject to a number of limitations, our data set allows us to trace return migration from the United States with a degree of precision comparable to survey data, but on a much larger scale and with original information on its possible determinants. For each individual in the data set, we estimate the year of entry, the likely entry channel (work or education), and the permanence spell up to either the return to India or 2016 (right-censoring year). By means of survival analysis, we provide estimates of the probability of return migration as a function of the conditions at migration (age, education, patenting record, migration motives, and migration cohort) as well as some activities undertaken while abroad (education and patenting).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Our results, albeit exploratory, find rather different patterns for work and education migrants. Considering the former, we find that Indian inventors’ return risk is positively associated with their age and education at migration, as well as their propensity to patent while in the US. As for education migrants, the return risk correlates negatively with the education level they attain. We also find some evidence of negative (positive) time-dependence for work (education) return migrants, which we interpret as indicative of negative (positive) self-selection with respect to unobservable skills acquired in the host country.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("We proceed as follows. In ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#ch1.2"
    }
  }, [_vm._v("section 1.2")]), _vm._v(", we present in a rather succinct way our database-building strategy (more details in the appendix: "), _c('a', {
    attrs: {
      "href": "http://www.nber.org/data-appendix/c14104/appendix.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nber.org/data-appendix/c14104/appendix.pdf")]), _vm._v("), introduce our own definitions of "), _c('em', [_vm._v("migrant")]), _vm._v(" and "), _c('em', [_vm._v("return migrant")]), _vm._v(", and propose some descriptive evidence. When necessary, we discuss some conceptual and methodological issues concerning the definition of "), _c('em', [_vm._v("return migrant")]), _vm._v(". In "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#ch1.3"
    }
  }, [_vm._v("section 1.3")]), _vm._v(", we present our model specification and discuss how it serves the purpose of investigating skill-based self-selection in return migration. In "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#ch1.4"
    }
  }, [_vm._v("section 1.4")]), _vm._v(", we perform the related econometric exercise and comment on the results. "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#ch1.5"
    }
  }, [_vm._v("Section 1.5")]), _vm._v(" concludes with a special focus on further research plans and some tentative policy implications.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "ch1.2"
    }
  }, [_c('strong', [_vm._v("1.2   Data: Methodology and Descriptive Statistics")])]), _vm._v(" "), _c('p', {
    staticClass: "h5a",
    attrs: {
      "id": "ch1.2.1"
    }
  }, [_vm._v("1.2.1   Methodology")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our data set originates from an ambitious data-linkage project between patent and inventor data gathered from PatentsView ("), _c('a', {
    attrs: {
      "href": "http://www.patentsview.org/web/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.patentsview.org/web/")]), _vm._v(") and biographical information extracted from a large number of LinkedIn profiles. PatentsView is a data repository recently made available by the United States Patent and Trademark Office (USPTO), which provides, among other things, disambiguated data on all the inventors of patents granted by the USPTO from 1975 onward, irrespective of their country of residence. LinkedIn, a well-known professional-oriented social network, represents an unparalleled source of information on the international mobility of individuals, as the members’ public profiles include information on names and (possibly) locations of their educational institutions and employers, along with graduation and recruitment years (Ge, Huang, and Png 2016; Zagheni and Weber 2015).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a pilot project, we focus on a subset of high-skilled migrants in the United States—namely, Indian inventors with ICT patents. This is a distinctive social group due to both its inventive contribution (Kerr and Lincoln 2010; Breschi, Lissoni, and Miguelez 2017) and its implication in two important temporary migration channels—namely, highly qualified temporary "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("work (most notably through the H-1B visa system; Kerr et al. 2015; Kapur and McHale 2005) and education (Finn 2014; Kapur and McHale 2005). It is also a highly represented group on LinkedIn, which in 2016 registered well over 100 million members in the US and over 30 million in India, with the two countries standing at the top of LinkedIn world rankings for both membership and traffic."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en3",
      "id": "rch1en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We extracted from PatentsView all the patents granted to the 179 largest US public firms in the ICT industry from 1975 to 2016 and the relative inventors for a total of 262,847 distinct individuals."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en4",
      "id": "rch1en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" We then proceeded to the ethnic analysis of such inventors’ names and surnames based on Global Name Recognition, a name search technology produced by IBM (from now on, IBM-GNR) and adapted to our purposes by Breschi et al. (2017). This allowed us to identify inventors of presumed Indian origin (from now on, Indian inventors) for a total of 24,017 individuals representing 9.1 percent of all inventors employed by the companies in our sample. Each Indian-named inventor was then matched to one LinkedIn profile based on name and company matching with extensive manual checking. This exercise yielded 10,839 inventors with valid LinkedIn accounts (around 45 percent of the original sample). For details, see sections C and D of the appendix.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We then proceeded to codify three major sets of variables, concerning education, employment, and patent records. On that basis, we also estimated the inventors’ years of birth as well as their migrant, non migrant, and return migrant status.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We coded information on education according to the 2011 version of UNESCO’s International Standard Classification of Education (ISCED) for educational levels from 3 (upper secondary) to 8 (doctoral or equivalent)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en5",
      "id": "rch1en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" After jointly treating ISCED levels 5 and 6 (respectively, short-cycle tertiary and bachelor’s) and distinguishing between master’s of arts and/or science and MBAs, we ended up with the following classification: upper secondary education, bachelor’s, master’s, MBA, and PhD, plus a residual unclassified category. We then geolocalized as many education institutions as possible at the country level by means of Google Maps and obtained at least one geolocalization per inventor. (For full details, see section E of the appendix.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for employment, we recorded the start and end years of each related employment spell as well as the employer’s name. We geolocalized the latter, at the country level, only on the basis of the information provided by the "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("LinkedIn profile, with no further attempt to use GoogleMaps, which would prove useless for multinationals with several branches and affiliates in multiple countries. Thus our estimates on migration and return migration for work reasons have to be considered extremely conservative. In section F of the appendix, we discuss some possible ways to improve them by capturing more return moves based on a more sophisticated treatment of LinkedIn information.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("As for the inventive activities of each inventor, we geolocalized them at the country level on the basis of the inventor’s address as reported on his or her various patents and dated them on the basis of the patent’s priority year (De Rassenfosse et al. 2013)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en6",
      "id": "rch1en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Based on the unique inventor ID provided by PatentsView, we could then calculate the number of patents signed by each inventor each year either in India or abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coming to the inventor’s year of birth, our preferred option was to estimate it on the basis of education information, with reference to the lowestlevel education achievement among those reported in the LinkedIn profile, the year of completion, and the presumed age at start (see section G in the appendix; see also Gaulé 2014). For the inventors whose profiles did not report any information on the timing or level of education, we estimated the year of birth based on the average age of the other inventors in the same patent cohort (i.e., the inventors who filed their first patents in the same year). In most cases, the age so calculated is around 32, which is close to general estimates by Jones (2009).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After dropping the inventors whose LinkedIn profiles did not provide sufficient information for estimating either the educational level or the year of birth, 8,982 observations remained (see table 1A.5 in the appendix). For these, we estimated the accuracy of our PatentsView-LinkedIn match based on around 1,000 LinkedIn profiles of Indian ICT professionals that report patent information. Based on around 800 “true positives” (successful matches of a LinkedIn profile to an inventor in PatentsView with coherent patent information) and 30 “false positives” (successful matches, but with discordant patent information), we calculated a 96.4 percent precision rate and a 77 percent recall rate. The high precision rate suggests that the education, employment, and age information in our data set are rather accurate (i.e., it is unlikely that they refer to the wrong inventor). However, the low recall rate suggests that our sample possibly suffers from truncation problems, to the extent that the excluded inventors may share some characteristics associated with the phenomenon of our interest (return migration)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en7",
      "id": "rch1en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("We finally proceeded to identify migrant and return migrant inventors to/from the United States, as described in detail by figures 1A.6 and 1A.7 in the appendix. We proceeded by elimination, first dropping from our sample all the inventors without any education, employment, or patenting records within India, who may include second-generation migrants or members of the historical Indian diaspora in the former British Commonwealth. Second, we dropped all those we consider nonmigrants—namely, the inventors without any education, employment, or patenting records outside India. Among the remaining inventors, we considered as “education migrants” all the inventors whose LinkedIn profiles report enrolment in foreign higher education institutions as the first events in their lives taking place outside India and occurring earlier than any patenting activity abroad. Similarly, we considered as “work migrants” all the inventors whose LinkedIn profiles report recruitment by foreign-based companies as the first events taking place outside India and/or who have at least one patent abroad dating to before any enrolment in foreign higher education institutions.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, we restricted our attention to migrants whose first moves outside India occurred in the United States. This left us with 3,943 “education migrants” and 1,589 “work migrants” from India to the United States for a total of 5,532 individuals. For the former, we considered as the migration year the starting year of the first education program undertaken in the United States. For the latter, we similarly defined the migration year as the beginning year of the first working spell in the United States or, alternatively, the priority year of the first patent. When distinguishing between “work” and “education” migrant inventors, it is important to keep in mind that the distinction refers only to the individuals’ condition at migration time. Nothing impedes a work migrant from entering a master’s or PhD program in the United States or impedes an education migrant from starting to work there. Indeed, the first case is rather frequent, and the second is very frequent.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Coming to return migration, we record as a returnee every migrant reporting ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("an employment or a patent in India after having moved to the United States. We do not record return events related to further education in India, but we suspect these to be very few. However, we record employment in higher education. As for the return year, this coincides with either the start of the relevant employment spell or the priority year of the relevant patent. All migrants for whom we do not observe any return event are considered as still living in the United States in 2016, our final year of observation. For the sake of simplicity, at this stage of our research, we do not code any event following the first return to India. Similarly, we ignore any move from the United States to a country other than India. For example, we will treat an Indian student in the United States who leaves for the United Kingdom after graduation as if he or she was staying in the United States. This implies that we ignore circular migration. A cursory look at our data, however, reveals very few instances of this type.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Albeit imperfect, our coding of return events (and, in consequence, permanence abroad) does not compare unfavorably with similar coding one can find in the literature. Borjas’s (1989) classic study based on the 1972–1978 Survey of Scientists and Engineers simply recorded as returnees all foreign respondents to the 1972 questionnaire who had left the sample by 1978. Gaulé (2014), who relied on several editions of the Directory of Graduate Research of the American Chemical Society from 1993 to 2007, first identified as potential returnees all foreign faculty and postdocs who appear at least once in the directory and then disappear. He then looked manually in bibliographic and web resources for information on the likely motives for the disappearance (to distinguish between return to the home country while not ceasing the academic career and moves to industry or third countries, and deaths). To our knowledge, the only accurate survey of return moves is provided by Gibson and McKenzie (2014), but for a very small sample."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en8",
      "id": "rch1en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even much-used resources for studying low-skill return emigration, such as the German Socio-economic Panel (GSOEP), are far from faultless. In some cases, they resort to measuring return intentions rather than actual moves."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en9",
      "id": "rch1en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.1a"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0025-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.1a   Estimated age at migration, education channel (percentage distribution of all education migrants to the United States)")])])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.1b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0025-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.1b   Estimated age at migration of work migrants (percentage distribution of work migrants to the United States)")])])]), _vm._v(" "), _c('p', {
    staticClass: "h5",
    attrs: {
      "id": "ch1.2.2"
    }
  }, [_vm._v("1.2.2   Descriptive Statistics")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In what follows, we produce a number of descriptive statistics that serve the dual purpose of checking the information contents and quality of our data and providing some basic evidence on the phenomenon under study.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.1a"
    }
  }, [_vm._v("Figures 1.1a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.1b"
    }
  }, [_vm._v("1.1b")]), _vm._v(" report the distribution of the age at migration for education and work education migrants, respectively. We notice that the overwhelming majority of the former move to the US at 23 or 24 years of "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("age, which is compatible with the age for starting a master’s course or possibly a PhD. The very sparse observations for ages less than 19 are due to either errors in our calculation of migrants’ years of birth or the very few Indian migrants who move to the US for bachelor’s studies. As for the very few apparently moving at older ages, especially over 30, they may be mature postgraduate students or professionals taking MBA courses. Figure 1A.12a in the appendix reports the distribution of age at migration for all Indian immigrants in science, technology, engineering, and mathematics (STEM) occupations for the migration cohorts 1990s and 2000s based on data from the American Community Surveys 2000 and 2010 (pooled samples; IPUMS US). Figure 1A.12b reports the same calculations for the subset of STEMemployed Indian immigrants with education at the college, master’s, or PhD level. The modal values are, respectively, 24 and 25, which is slightly higher than for our educational sample. Moreover, the age at migration distribution taken from IPUMS data is flatter. Again, as our sample is composed of educational migrants, this concentration in early ages of migration is expected.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("For comparison purposes, we also look at the number of H-1B petition filings by age for the years 2007–2017 from the US Citizenship and Immigration Services (figure 1A.13 in the appendix). The most numerous group is the one at ages 25–34, followed by the 35–44 group. Again, this is slightly different from our education sample. In this regard, ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.1b"
    }
  }, [_vm._v("figure 1.1b")]), _vm._v(" shows the distribution of the age at migration as way more skewed to the right. However, the figure shows a high peak at 32, which also differs from figures 1A.12 and 1A.13 and seems to be a statistical artifact that results from the inclusion in this migrants category of many inventors with two characteristics. First, for want of better information, we estimate their ages based on the priority year of their first patents. Second, they appear on these patents with US addresses, and this is the earliest evidence we have of their migration. Yet we notice that the age distribution is rather symmetric around 32. This is compatible with migrants in this group moving abroad after completing their education in India and starting their careers there, as happens with many H-1B visa holders, as well as being employees of Indian firms temporarily detached to the United States. When excluding from the work migrants all inventors whose ages were determined by the year of the first patent, the shape of the distribution does not change much, since the modal value remains at 32 and the symmetry is preserved (figure 1A.15 in the appendix). However, the percentage of people migrating at 32 goes from 20.2 percent to 13 percent in figure 1A.15, which is significant. In any case, we should be cautious when interpreting the estimates of the effect of age at migration on return decisions (for work migrants).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.1"
    }
  }, [_vm._v("Table 1.1")]), _vm._v(" provides a breakdown of our data set by migration motives and cohorts (decades during which migration occurred). Two features emerge. "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("First, most migrants in our sample belong to the 1990s and 2000s cohorts. This is broadly compatible with historical records of high-skilled Indian migration to the United States (Desai, Kapur, and McHale 2005) but also possibly emphasized by the characteristics of our LinkedIn records—namely, right truncation at 2016 and underreporting for the earlier cohorts (the older an individual, the less likely he or she is to maintain a LinkedIn profile).")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('div', {
    staticClass: "page"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tcaption",
    attrs: {
      "id": "tab1.1"
    }
  }, [_c('strong', [_vm._v("Table 1.1   Migrants to the United States by cohort and channel")])]), _vm._v(" "), _c('div', {
    staticClass: "tablequery"
  }, [_c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "thead-bordertb"
  }, [_vm._v("Channel")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("1960")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("1970")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("1980")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("1990")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("2000")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("2010")]), _vm._v(" "), _c('td', {
    staticClass: "theadr-bordertb"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablest"
  }, [_vm._v("Education")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("102")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("697")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("1,739")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("1,315")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("71")]), _vm._v(" "), _c('td', {
    staticClass: "tablert"
  }, [_vm._v("3,943")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables1"
  }, [_vm._v("% column")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("95.3")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("95.2")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("85.9")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("56.3")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("22.8")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("71.3")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Work")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("35")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("286")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("1,022")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("241")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("1,589")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables1"
  }, [_vm._v("% column")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("0.0")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("4.7")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("4.8")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("14.1")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("43.7")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("77.2")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("28.7")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("All channels")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("107")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("732")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("2,025")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("2,337")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("312")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("5,532")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables1"
  }, [_vm._v("% column")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")]), _vm._v(" "), _c('td', {
    staticClass: "tabler"
  }, [_vm._v("100")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables1-borderb"
  }, [_vm._v("% row")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("0.3")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("1.9")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("13.2")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("36.6")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("42.2")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("5.6")]), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }, [_vm._v("100")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    staticClass: "tablequery",
    attrs: {
      "alt": "image",
      "src": "html/images/f0027-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second, the importance of the education channel relative to the work channel is both evident for early cohorts and declining over time. This trend again is broadly compatible with the history of graduate and postgraduate education in India since the 1960s, whose offer and quality were extremely limited until the 1990s (so an early Indian migrant seeking a job in science or engineering usually obtained a graduate education in the host country; Kapur 2010). But it may be accentuated, once again, by underreporting for early cohorts and its correlation with educational levels (the more likely an individual is to have migrated through the work channel, which is associated with a lower education level, the less likely he or she is to maintain a LinkedIn profile, especially in the case of an older individual). These observations suggest that our data are more reliable for the 1990s and 2000s cohorts, which concern 4,362 individuals—namely, 79 percent of migrants in our database.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.2a"
    }
  }, [_vm._v("Figures 1.2a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.2b"
    }
  }, [_vm._v("1.2b")]), _vm._v(" provide further details on the education levels of both education and work migrants. We first remark on how the overwhelming majority of the former and the relative majority of the latter hold masters’ degrees. This suggests that PhD holders and academic scientists, for which Finn (2014), Gaulé (2014), and Kahn and MacGarvie (2016) have provided some evidence, are not a representative sample of migrant inventors in the ICT industry. We also notice that the share of doctorate holders is higher for education-based migrants, while the share of bachelor holders is higher for work-based ones, which is in line with our selection criteria for the two categories.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.2a"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0028-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.2a   Highest educational attainment, percentage distribution: education migrants")])])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.2b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0028-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_vm._v("Fig. 1.2b   Highest educational attainment, percentage distribution of work migrants")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.3"
    }
  }, [_vm._v("Figure 1.3")]), _vm._v(" reports the total return rates for all migrants in our sample (irrespective of length of stay) by migration channel. For comparative purposes, the return rates are calculated both according to the definition of returnee we adopted earlier (first job or patent back in India, as per LinkedIn profile) and to a purely patent-based definition (first patent back in India, irrespective of other information). The latter corresponds to that found in most of the available literature on the international mobility of inventors, which relies exclusively on patent data and can observe a cross-border move only for inventors with at least two patents in as many different countries (e.g., Oettl and Agrawal 2008). We notice immediately that this definition severely underestimates return rates (black bars) compared to the one also based on job information (white bars), whatever migration channel we consider. In fact, the latter also includes among the returnees the inventors "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("with no more than one patent in their careers (either in the United States or in India) but education or employment in a different country than the one where that only patent was signed. More generally, it also counts as returnees the inventors whose entire patent production occurred in one country but whose education or career took place elsewhere.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_vm._v("Fig. 1.3   Total return rates by migration channel (irrespective of the length of stay in the United States)")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("When comparing migration channels, ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.3"
    }
  }, [_vm._v("figure 1.3")]), _vm._v(" reports a seven-point difference in the return rate of work-migrant inventors compared to education ones. This may be due to the different types of visas used to enter the United States in terms of both initial validity length and renewal ease and also different efforts that work and education migrants may make to convert their temporary visas into permanent ones. Different types of migrants may also be differently exposed to opportunities to establish social ties in the United States, which may influence their propensity to return at each point in time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.4a"
    }
  }, [_vm._v("Figures 1.4a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.4b"
    }
  }, [_vm._v("1.4b")]), _vm._v(" report the total return rates (based on both patent and job information) for different cohorts of migration to the United States. The return rates for education migrants appear to be increasing, and this is despite the longer observation interval for older cohorts (which intuitively should lead to more accumulated returns). However, for cohorts before 1990, the number of observations is rather limited, and as discussed in the previous subsection, the probability of underreporting by return migrants is rather high. As for the 2010 cohort, once again we are faced with very few observations, which makes the very high return rate figure extremely unreliable. Once again, we can trust only the data for the 1990 and 2000 cohorts, which still exhibit different return rates.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Contrary to education migrants, the return rates of work migrants appear rather stable, especially for recent cohorts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As discussed in the introductory part of the chapter, the return rates found "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("in the literature vary considerably depending on the sample and countries analyzed. While Finn (2014) calculates a return rate just after graduation of about 10 percent for India (up to around 15 percent in more recent estimates; Finn and Pennington 2018), other studies report return rates of around 40 percent both for Indian H-1B visa holders (Lowell 2000) and for Indian PhD or master’s students (Wadhwa 2009).")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.4a"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.4a   Percentage of education migrants returning to India by cohort (irrespective of the length of stay)")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.4b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0030-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_vm._v("Fig. 1.4b   Percentage of work migrants returning to India by cohort (irrespective of length of stay)")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.5"
    }
  }, [_vm._v("Figure 1.5")]), _vm._v(" reports the Kaplan-Meier estimators for work and education migrants from the 1990 and 2000 cohorts, with time measured yearly. We notice that the survival (stay) rate for work migrants is both lower and more "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("rapidly decreasing over time than for education ones. We also notice that the stay rate after 10 years since migration for education migrants (slightly less than 90 percent) is very close to what is reported by Finn (2014) for Indian PhD graduates in the United States. We take this as a sign of the reliability of our data.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0031-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_vm._v("Fig. 1.5   Stay rates over time (years since migration) by migration channels (1990 and 2000 cohorts)")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.2"
    }
  }, [_vm._v("Table 1.2")]), _vm._v(" provides detailed information on the return time for migrant inventors in the 1990 and 2000 cohorts. Returnees in the first cohort leave the United States, on average, 11 years after their arrival. The minimal return time is zero (which implies a return to India less than a year after entry into the United States), and the value of the first quartile is 5.5. This indicates that 25 percent of the returnees in the 1990 cohort go back to India either in the same year of their arrival or not later than 5.5 years afterward. An additional 25 percent leave between 5.5 and 11 years after their arrival, followed by 25 percent more who leave between 11 and 16 years. The maximum stay, for returnees, is 25 years. When splitting the 1990 cohort between work and education returnee migrants, the former exhibit shorter stay periods both on average and according to the quartile distribution. The 2000 cohort exhibits, on average, shorter stays than the 1990 one (which may be due to shorter exposure to the return risk) but also less striking differences between work and education migrants.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "ch1.3"
    }
  }, [_c('strong', [_vm._v("1.3   Specification")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We exploit our data to explore the extent of skill-based self-selection in return migration of the highly skilled. Skill-based self-selection was first investigated by Borjas (1989) in order to provide an explanation for two common stylized facts concerning the education and income levels of migrants. "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("First, stock data on foreign-born versus native populations recurrently show that the former are, on average, better educated than the latter for most traditional destination countries. Second, when observing a cohort of foreignborn over time through successive censuses, it is often found that starting from a lower average wage or income level, migrants catch up relatively quickly. Regardless of whether migrants are positively self-selected at entry, with respect to their education and/or unobservable skills, negative selfselection may help explain this evidence to the extent that return migrants escape successive censuses, therefore leaving behind them, in the host country, only the best and brightest of their respective immigration cohorts.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "page"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tcaption",
    attrs: {
      "id": "tab1.2"
    }
  }, [_c('strong', [_vm._v("Table 1.2   Average time to return by cohort")])]), _vm._v(" "), _c('div', {
    staticClass: "tablequery"
  }, [_c('table', {
    staticClass: "tab3"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "thead-bordertb"
  }), _vm._v(" "), _c('td', {
    staticClass: "thead-bordertb"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("All channels")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Education")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Work")]), _vm._v(" "), _c('td', {
    staticClass: "thead-bordertb"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablect-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_c('em', [_vm._v("Cohort 1990")])]), _vm._v(" "), _c('td', {
    staticClass: "tablect-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablect-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablest"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablest"
  }, [_vm._v("# of inventors in cohort")]), _vm._v(" "), _c('td', {
    staticClass: "tablerct"
  }, [_vm._v("2,025")]), _vm._v(" "), _c('td', {
    staticClass: "tablerct"
  }, [_vm._v("1,739")]), _vm._v(" "), _c('td', {
    staticClass: "tablerct"
  }, [_vm._v("286")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("# of returnees")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("471")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("383")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("88")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Mean")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("10.58811")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("11.22193")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("7.829545")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Std")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("6.643841")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("6.71642")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("5.560992")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Min")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("25%")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("5.5")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("50%")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("11")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("75%")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Max")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("25")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc-borderb"
  }, [_vm._v("25")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc-borderb"
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('em', [_vm._v("t")]), _vm._v("-test 4.952 ("), _c('em', [_vm._v("p")]), _vm._v("-value 0.000)")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-bordertb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-bordertb"
  }, [_c('em', [_vm._v("Cohort 2000")])]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablest"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablest"
  }, [_vm._v("# of inventors in cohort")]), _vm._v(" "), _c('td', {
    staticClass: "tablerct"
  }, [_vm._v("2,337")]), _vm._v(" "), _c('td', {
    staticClass: "tablerct"
  }, [_vm._v("1,315")]), _vm._v(" "), _c('td', {
    staticClass: "tablerct"
  }, [_vm._v("1,022")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("# of returnees")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("626")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("325")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("301")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Mean")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3.889776")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("4.132308")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3.627907")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Std")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3.897362")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("4.316674")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3.374574")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Min")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("25%")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("50%")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("75%")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablerc"
  }), _vm._v(" "), _c('td', {
    staticClass: "tables"
  }, [_vm._v("Max")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc-borderb"
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc-borderb"
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    staticClass: "tablerc"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabler-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabler-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('em', [_vm._v("t")]), _vm._v("-test 1.635 ("), _c('em', [_vm._v("p")]), _vm._v("-0.103)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticClass: "tablequery",
    attrs: {
      "alt": "image",
      "src": "html/images/f0032-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tnote"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Cohort 1990 includes inventors who migrated to the US between 1990 and 1999; cohort includes inventors who migrated to the US between 2000 and 2009.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Borjas and Bratsberg (1996) provide a classic treatment of the topic, in which they show that different remuneration levels of skills in the host and home countries jointly determine whether migrants will be positively (negatively) self-selected upon arrival and, conversely, negatively (positively) ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("selected upon return. In other words, return migration is expected to re inforce the sign of skill-based self-selection at entry. Dustmann and Görlach (2016) provide the last in a series of refinements of this basic idea, which describes the migrant’s behavior at his or her destination (including his or her investment in the acquisition of education and skills) as resulting from the same lifetime optimization plan that determines the return decision and timing.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Other, less-dominant theories of return migration stress the fact that many migrants neither move permanently to the host country nor return home once and for all after a prolonged spell abroad. Instead, they move back and forth between the home and the host countries (or several host countries), possibly in response to economic shocks (Constant, Nottmeyer, and Zimmermann 2013). In this case, we should not expect any positive or negative self-selection, the economic shocks being orthogonal to skill levels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Empirical studies on return migration can be categorized according to two criteria: (a) whether they observe and explain the actual duration of migration spells, from entry to return, or simply compare the characteristics of stayers and returnees; and (b) whether they focus on observed return moves or on return intentions.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("With respect to (a), empirical studies fall into one or the other category depending on data availability and, to a lesser extent, on their theoretical focus. On the data side, most studies simply do not have longitudinal information on individual migrants—that is, they have no records on entry and return dates. Based on this limited information, they can only apply linear probability or logit/probit models and investigate the determinants of the probability to return, irrespective of when this occurs. When longitudinal data are available, instead, one can apply duration analysis (also known as survival or event history analysis; Allison 2014). This has two advantages over linear probability or logit/probit models. First, it is not inherently static, and therefore it allows one to consider time-varying covariates, so as to study how intervening changes in the migrant’s characteristics may affect the return decision. Second, and more importantly, duration analysis allows estimating the propensity to return for those who have not yet returned, at each point in time during their entire permanence abroad, and not just the probability to return after a pre-determined spell abroad (say one, two or five years). By derivation, one can explain or predict the timing of the return decision and not just the probability of its occurrence. This also implies that by means of duration analysis, we can test whether the probability to return is time-dependent, either positively or negatively. According to Constant and Massey (2002), negative time dependence may be indicative of negative skill-based self-selection (where skills are unobservable). The longer a migrant stays in the host country, the more country-specific skills he or she accumulates, which are hard to transfer and/or are less remunerated at home, ceteris paribus. This makes return increasingly less likely. At the same time, ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("to the extent that migrants vary in the speed at which they accumulate local skills, early returnees would necessarily be those who, at a given point in time, have accumulated fewer local skills.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Coming to the distinction between studies based on observed return moves or declared return intentions, this often boils down, once again, to data availability, with survey data being much better at recording the latter than the former (see our earlier discussion on how we record return moves). However, some recent literature suggests that data on return intentions better serve the purpose of testing lifetime income maximization models. This is because, according to such theories, most migrants leave their countries with the intention to return at a date which depends on their investment plans in education and skill acquisition while abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The data structure for our regression exercises is a panel one, with each inventor "), _c('em', [_vm._v("i")]), _vm._v(" being observed repeatedly since his or her immigration year until the minimum between his or her return year (when he or she exits the panel) and 2016, our last observation year. In this way, we have a large number of right-censored observations, but no left-censored ones. In what follows, we exploit this feature of our data and estimate the determinants of actual return decisions by means of discrete time duration analysis. Given the exploratory nature of our exercise, we do not put forward any claim of having established causal links. We care instead for producing much-needed evidence on return frequency and timing and its association to observable and unobservable skills (i.e., self-selection based on education, patenting activity, and time spent in the United States).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following Jenkins (2005), we assume a proportional hazard function, which, in a discrete time setting such as ours, results in a complementary log-log (cloglog) model, as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "equation"
  }, [_c('em', [_vm._v("h")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(", "), _c('em', [_vm._v("x")]), _vm._v(")"), _c('sub', [_c('em', [_vm._v("i")])]), _vm._v(" = 1 − exp[−exp("), _c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(") + β"), _c('sub', [_c('em', [_vm._v("i")])]), _c('em', [_vm._v("X")]), _c('sub', [_c('em', [_vm._v("i")])]), _vm._v(")],")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where "), _c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(") represents a generic inventor’s baseline probability to return home after a migration spell "), _c('em', [_vm._v("t")]), _vm._v(" (duration), conditional on not having yet returned, and β"), _c('sub', [_c('em', [_vm._v("i")])]), _c('em', [_vm._v("X")]), _c('sub', [_c('em', [_vm._v("i")])]), _vm._v(" is a scaling factor depending on specific inventor "), _c('em', [_vm._v("i")]), _vm._v("’s characteristics "), _c('em', [_vm._v("X")]), _c('sub', [_c('em', [_vm._v("it")])]), _vm._v(" (some of which are time-variant). As for "), _c('em', [_vm._v("t")]), _vm._v(", we measure it as either the number of years (plus 1) spent in the US since immigration or, for conducting robustness checks on education migrants only, the number of years since the end of their first education spell in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Concerning the baseline hazard ratio "), _c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v("), we adopt two alternative specifications. First, we follow Constant and Massey (2002) and enter "), _c('em', [_vm._v("t")]), _vm._v(" with a quadratic term, as follows:")]), _vm._v(" "), _c('table', {
    staticClass: "tab-q"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "eq1.1"
    }
  }, [_vm._v("(1)")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(") = α"), _c('sub', [_vm._v("1")]), _c('em', [_vm._v("t")]), _vm._v(" + α"), _c('sub', [_vm._v("2")]), _c('em', [_vm._v("t")]), _c('sup', [_vm._v("2")]), _vm._v(".")])])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("This parametric specification may allow us to test for any time dependence of the hazard ratio, and its sign, in a rather immediate and intuitive way, on ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("the basis of estimates for α"), _c('sub', [_vm._v("1")]), _vm._v(" and α"), _c('sub', [_vm._v("2")]), _vm._v(". But it comes at the cost of imposing a specific functional form to "), _c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Second, we experiment with a nonparametric specification (as in Gaulé 2014) and make use of fixed effects, as follows:")]), _vm._v(" "), _c('table', {
    staticClass: "tab-q"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "eq1.2"
    }
  }, [_vm._v("(2)")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(") = η"), _c('sub', [_vm._v("1")]), _c('em', [_vm._v("t")]), _c('sub', [_vm._v("1")]), _vm._v(" + . . . + η"), _c('sub', [_c('em', [_vm._v("N")])]), _c('em', [_vm._v("t")]), _c('sub', [_c('em', [_vm._v("N")])]), _vm._v(",")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where ("), _c('em', [_vm._v("t")]), _c('sub', [_vm._v("1")]), _vm._v(" . . . "), _c('em', [_vm._v("t"), _c('sub', [_vm._v("n")])]), _vm._v(") is a set of duration dummies corresponding to migration spells lasting from 1 to N years (and N is the longest spell observed in our data). This model has the advantage of not imposing any functional form to the hazard ratio, but it produces so many estimated coefficients that in order to appreciate any time dependence of the hazard ratio, one needs a graphical representation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Based on the evidence from ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.4a"
    }
  }, [_vm._v("figures 1.4")]), _vm._v(" to "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.6a"
    }
  }, [_vm._v("1.6")]), _vm._v(", plus "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.2"
    }
  }, [_vm._v("table 1.2")]), _vm._v(", in the previous section, we expect time to affect differently the hazard ratio of work- and education-based migrant inventors. Hence we run separate regressions for the two types of migrant inventors. We also restrict our regressions to the two most populated migration cohorts in our sample—namely, the 1990s and the 2000s ones, for which data are more reliable. We also right-censor our data at 2016 as a matter of convenience. This makes the longest possible duration equal to 27 years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coming to our choice of regressors "), _c('em', [_vm._v("X")]), _c('sub', [_c('em', [_vm._v("i")])]), _vm._v(", they include both a set of timeinvariant variables that describe the migrant’s conditions at entry in the United States and a set of time-variant ones that describe his or her activities during his or her permanence there (see "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.3"
    }
  }, [_vm._v("table 1.3")]), _vm._v(" for descriptive statistics).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for conditions at entry, we consider the inventor’s age, educational level, migration cohort, and patenting experience at migration, all of which we expect to be positively associated to the return hazard, as they may proxy for the inventor’s stronger attachment or professional insertion in India and may negatively affect his or her chance to renew the initial temporary visa. We measure age in years ("), _c('em', [_vm._v("Age at migration")]), _vm._v(") and education with the dummy variable "), _c('em', [_vm._v("Master’s or more at migration")]), _vm._v(" (the reference case being that of migrants with no more than a bachelor’s at migration; as for doctorate holders, they are too few to create a meaningful separate category, so we treat them as master’s holders). Due to our restriction of the analysis to just two migration cohorts, we control for them with just a dummy for the 2000s one (1990s as reference). As for patenting experience, we measure it with the cumulative number of patents signed at the time of migration ("), _c('em', [_vm._v("Patent stock at migration")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("As for activities in the United States, we consider the following:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_vm._v("• the migrant’s student status ("), _c('em', [_vm._v("Student")]), _vm._v("), which is a dummy taking a value of one for all the years between the start and end years of an education spell in the United States, whatever its level, and zero otherwise;")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("• the migrant’s educational attainment while in the United States, as measured by the dummy variables "), _c('em', [_vm._v("Master’s")]), _vm._v(" and "), _c('em', [_vm._v("PhD")]), _vm._v(", which takes a value of zero before the year of completion of, respectively, the migrant’s master’s or doctoral studies, and one thereafter;")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "bulllist"
  }, [_vm._v("• the migrant’s productivity as an inventor while abroad, which we measure with the "), _c('em', [_vm._v("cumulative number of patents")]), _vm._v(" from entry into the United States up to observation time "), _c('em', [_vm._v("t")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("We expect the student status to lower return hazard, as it guarantees the migrant the renewal of his or her temporary visas. As for the educational attainment, based on the existing evidence of Indian graduates’ low return rates, we also expect a negative impact on the return hazard. In other words, we expect negative self-selection based on education. As for the number of patents filed in the United States, we would expect negative self-selection, but the interpretation of this variable is complicated by the fact that not all migrants in our sample, once in the United States, pursue careers as inventors but may instead move on to management, entrepreneurship, or academia. (We come back to this issue when commenting on the results.)")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "ch1.4"
    }
  }, [_c('strong', [_vm._v("1.4   Results")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.3"
    }
  }, [_vm._v("Table 1.3")]), _vm._v(" reports separate descriptive statistics for the education and work migration channels. We notice some important differences between education and work migrants besides the age at migration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, work migrants are considerably more likely to leave India after graduating at the master’s level; most education migrants move to the United States precisely to earn that same degree. As for earning a PhD, this happens almost exclusively to education migrants. In this respect, it is important to remark that this may happen on top of getting a master’s but also as an alternative to it, with the latter case being the most frequent."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en10",
      "id": "rch1en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both education and work migrants exhibit a rather low average number of patents before moving to the United States, but the figures are higher for the latter. At a closer inspection, our data reveal that most migrants in our sample leave India without having filed any patent there. In fact, only about 1 percent of education migrants and 4 percent of work migrants have a nonnull patent record before migrating. As for the cumulative number of patents filed while in the United States, its average value is higher for work migrants than for education ones (around five against four). When looking at the underlying distribution (unreported in the table), we notice that only 2 percent of work migrants never file any patent while in the United States, while the same figure for education migrants amounts to 14 percent (the overwhelming majority of these individuals patent only when they return to India, while a tiny minority may have patents before migrating). As for those who filed at least one patent in the United States, the differences between work and education migrants are much less striking, albeit education migrants exhibit more variability (witness the standard error reported in "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.3"
    }
  }, [_vm._v("table 1.3")]), _vm._v("). In both subsamples, over a third of migrants file just one patent while in the United States and as many file from two to five (followed by a very long tail for values higher than ten), but education migrants are slightly more likely to file just one patent, or two to five, as well as more than one hundred.")]), _vm._v(" "), _c('div', {
    staticClass: "page"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tcaption",
    attrs: {
      "id": "tab1.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('strong', [_vm._v("Table 1.3   Descriptive statistics by migration channel")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "tablequery"
  }, [_c('table', {
    staticClass: "tab4"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "thead-bordert"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Education channel")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-bordertr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-bordert"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Work channel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "theadc-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Obs")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Mean")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Std. dev.")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Min")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Max")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-borderrb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Obs")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Mean")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Std. dev.")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Min")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Max")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablest"
  }, [_vm._v("Migration cohort")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("1,993.1     ")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("4.630")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("1,990")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("2,000")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("1996.8  ")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("4.648")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("1,990")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("2,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Age at migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("24.32  ")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("2.652")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("     18")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("     52")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("31.87")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("5.956")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("     18")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("     62")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Master’s or more at migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.09")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.283")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.34")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.473")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Current student status")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.20")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.403")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.04")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.192")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Master’s in the US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.66")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.474")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.04")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.202")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("PhD in the US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.20")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.400")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.01")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.097")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("MBA in the US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.08")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.267")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.04")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.201")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Patents at migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.01")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.114")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       5")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.03")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.354")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("     12")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables-borderb"
  }, [_vm._v("Cumulative # patents US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("3.83")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("10.64    ")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("    261")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderrb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("4.71")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("9.07")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("       0")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v(" 162")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    staticClass: "tablequery",
    attrs: {
      "alt": "image",
      "src": "html/images/f0037-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("We notice an important difference between education and work migrants with respect to the number of patents filed while in the United States, which on average is higher for the latter. As for the very high maxima that we observe for this variable, they correspond to very senior principal scientists in large ICT companies."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en11",
      "id": "rch1en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.4"
    }
  }, [_vm._v("Table 1.4")]), _vm._v(" reports the results of our regressions, which we run separately for education and work migrants. The first two columns refer to parametric specification (1) of the baseline hazard ratio "), _c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v("), while the other two refer to the nonparametric specification (2). In both cases, we calculate the estimated odds ratios, which we read as the marginal effects of the covariates on the return hazard ratio (Jenkins 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We first ask to what extent return migrants appear to be self-selected with respect to either one of their observable skills, namely, education and patenting activity. We then move on to analyze the sign of time dependence of the hazard ratio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Concerning education, we first notice that the odds ratio for "), _c('em', [_vm._v("Master’s or more at migration")]), _vm._v(" is greater than one in all columns of "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.4"
    }
  }, [_vm._v("table 1.4")]), _vm._v(", but it is significant in only one case (for education migrants in column 1). Hence there is evidence of return migrants being positively selected with respect to education they obtained in India, but it is rather weak. On the contrary, all return migrants appear to be negatively selected with respect to education obtained in the United States. For education migrants, both "), _c('em', [_vm._v("Master’s in the US")]), _vm._v(" and "), _c('em', [_vm._v("PhD in the US")]), _vm._v(" have estimated odds ratios largely inferior to one (the reference case being migrants obtaining only a bachelor’s degree or not completing their graduate studies).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the difference between the underlying coefficients is nonsignificant, which suggests that for individuals holding either a master’s or a PhD, graduate education is all that matters, and more advanced or researchoriented degrees do not convey any particular advantage to migrants intending to stay in the United States or to those with return intentions. As for "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("those holding both a master’s and a PhD, however, the two effects may sum up, which reinforces the negative selection effect of education on return migrants.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('div', {
    staticClass: "page"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tcaption",
    attrs: {
      "id": "tab1.4"
    }
  }, [_c('strong', [_vm._v("Table 1.4   Event history analysis of return risk, discrete time analysis, by migration channel")])]), _vm._v(" "), _c('div', {
    staticClass: "tablequery"
  }, [_c('table', {
    staticClass: "tab3"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "theadc-bordertb"
  }), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Education"), _c('br'), _vm._v("channel"), _c('br'), _vm._v("(1)")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Work"), _c('br'), _vm._v("channel"), _c('br'), _vm._v("(2)")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Education"), _c('br'), _vm._v("channel"), _c('br'), _vm._v("(3)")]), _vm._v(" "), _c('td', {
    staticClass: "theadc-bordertb"
  }, [_vm._v("Work"), _c('br'), _vm._v("channel"), _c('br'), _vm._v("(4)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablest"
  }, [_vm._v("Time from migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("      0.881***")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("      0.883***")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0201)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0307)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Time from migration2")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.005***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.002")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      (0.000830)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00195)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Migration cohort = 2000")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.779***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.423***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.867***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.424***")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.138)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.168)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.150)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.170)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Age at migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.872***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.899***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.977")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.904***")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00565)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00467)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0159)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0115)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Master’s or more at migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.623***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.154")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.180")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.138")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.227)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.136)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.176)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.139)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Current student status")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.595***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.160***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.459***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.173***")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0681)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0809)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0908)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0884)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Master’s in the US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.432***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.724")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.568***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.719")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0444)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.215)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0709)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.216)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("PhD in the US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.552***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.259")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      0.585***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.430")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0744)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.763)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0805)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.835)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("MBA in the US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.866")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    0.401**")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    0.711**")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    0.403**")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.148)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.169)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.124)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.171)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Patents at migration")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      2.525***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.429***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      2.320***")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("      1.431***")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.358)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0842)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("(0.301)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("  (0.0822)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Cumulative # patents US")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1.001")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    1.011**")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("0.999")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    1.012**")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00429)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00528)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00524)")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("    (0.00528)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tablest"
  }, [_vm._v("Observations")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("15,333")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("50,211")]), _vm._v(" "), _c('td', {
    staticClass: "tablect"
  }, [_vm._v("15,094")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Times dummies")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("NO")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("NO")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("YES")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("YES")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("# unique inventors")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("3,054")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1,308")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("3,054")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("1,308")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables"
  }, [_vm._v("Chi2")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("11,757")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("4,625")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("11,347")]), _vm._v(" "), _c('td', {
    staticClass: "tablec"
  }, [_vm._v("4,604")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tables-borderb"
  }, [_vm._v("LogL")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("−3,623")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("−1,684")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("−3,442")]), _vm._v(" "), _c('td', {
    staticClass: "tablec-borderb"
  }, [_vm._v("−1,664")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticClass: "tablequery",
    attrs: {
      "alt": "image",
      "src": "html/images/f0039-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tnote"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Inventor-level clustered standard errors in parentheses. *** "), _c('em', [_vm._v("p")]), _vm._v(" < 0.01, ** "), _c('em', [_vm._v("p")]), _vm._v(" < 0.05, * "), _c('em', [_vm._v("p")]), _vm._v(" < 0.1.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for work migrants, neither "), _c('em', [_vm._v("Master’s in the US")]), _vm._v(" nor "), _c('em', [_vm._v("PhD in the US")]), _vm._v(" is significant, and what really seems to count to increase their chances of staying in the United States is getting an MBA, whose coefficient is way less than 1, although significant only at 95 percent. Notice that "), _c('em', [_vm._v("MBA in the US")]), _vm._v(" also appears significant in one of the regressions for education migrants, but with an odds ratio closer to one.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Coming to patenting activity, inventors who leave India with substantial patenting experience are definitely those with the higher return hazard: witness the size of the odds ratio of Patents at migration for both education and ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("work migrants (respectively, well over 2 and close to 1.5). Whether this result can be interpreted as evidence of positive self-selection (in contradiction with the education-based negative self-selection) is doubtful. The number of individuals in our sample with at least one patent at migration is very limited, and for several of them, we may overestimate the occurrence of return."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#ch1en12",
      "id": "rch1en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for the patenting activity in the United States ("), _c('em', [_vm._v("Cumulative # patents US")]), _vm._v("), we also find it to be positively related to the return hazard, with odds ratios barely larger than one and not significant for education migrants. However, rather than being related to positive self-selection, this result may be related to specialization. In fact, inventors in our database range from the occasional to the professional ones, the former having signed one or very few patents before or after migration, the latter displaying instead a significant patenting record, one that possibly spans several years. In the absence of information on the migration strategies adopted by individuals in our sample or on the opportunity and constraints that may shape them, we can speculate about what follows. Professional inventors are more likely to move to the United States on a strictly temporary basis and for the specific task of undertaking inventive activities there, possibly on request of their employer in India, which organizes their two-way trip. Occasional inventors instead may be a more heterogeneous group, which includes a large number of individuals moving to the United States on their own initiative, rather than their employer’s, and more determined to turn an originally temporary visa into a permanent one. They will be at once more open toward different career options and less bound by the original visa arrangements. For example, they may move out of the research and development (R&D) laboratory and stop producing patents, possibly to undertake managerial functions or an entrepreneurial career, thus getting more chances to stay in the United States. This interpretation fits with the size and significance ratio of the MBA in the US variables, on which we commented above. Notice that this explanation applies better to work migrants than education ones, all of them entering the United States via a higher education program and therefore more likely to be occasional rather than professional inventors. This is coherent with the odds ratios for "), _c('em', [_vm._v("Cumulative # patents US")]), _vm._v(" being de facto equal to one in the regressions for education migrants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moving to time dependence of the hazard ratio, the estimated odds ratios in columns (1) and (2) suggest it to be negative and monotonic for work "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("migrants (the coefficient for the time-squared is not significant) but possibly nonmonotonic for education ones (the coefficient for the time-squared is significant, and the odds ratio is greater than one).")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Following Constant and Massey (2002), we interpret the negative time dependence of the return hazard ratio as indicative of some negative selfselection with respect to unobservable skills the migrant acquires through experience in the host country that are not as well rewarded back at home. Admittedly, Constant and Massey’s interpretation of the time-dependence of the hazard ratio is rather speculative, since other factors besides skill accumulation may intervene, such as increasing investments in real estate or social capital, both of which increase the opportunity cost of return. Still, the negative time dependence we find for work migrants is coherent with the possibility that those among them who stay longer in the United States also engage in managerial functions or undertake entrepreneurial careers. Such career moves come with developing skills for which the USIndia remuneration gap may be higher than that for the skills exclusively associated with R&D-performing tasks, thus discouraging return. They may also come with job contracts for which it is easier to obtain a permanent visa than a temporary one.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("As for the time pattern of education migrants’ return hazard ratio, regression in column (1) is not very enlightening. First, it results from imposing a parametric form to "), _c('em', [_vm._v("c")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v("); second, it requires one to understand whether opposite signs of the estimated coefficients for α"), _c('sub', [_vm._v("1")]), _vm._v(" and α"), _c('sub', [_vm._v("2")]), _vm._v(" imply some nonmonotonicity, which is not immediately clear in the case of nonlinear estimation methods such as cloglog. For this reason, we prefer relying on the results of the nonparametric estimation of column (3). Based on such results, ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.6a"
    }
  }, [_vm._v("figures 1.6a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.6b"
    }
  }, [_vm._v("1.6b")]), _vm._v(" report the within-sample estimates of the total hazard ratio "), _c('em', [_vm._v("h")]), _vm._v("("), _c('em', [_vm._v("t")]), _vm._v(") as a function of time and for different educational levels by migration cohort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both figures suggest that the return hazard follows an inverted U-shaped function of time over the first 13 years of permanence in the United States. After that, we cease to observe migrants in the 2000 cohort, due to right truncation, while the return rate for the 1990 cohort starts increasing again, albeit erratically. The hazard ratios for the early years after entry, however, may be underestimated. This is because we produced the graph by setting "), _c('em', [_vm._v("Current student status")]), _vm._v(" equal to zero, while in reality it should be equal to one from entry in the United States until graduation (notice that the odd ratios for "), _c('em', [_vm._v("Current student status")]), _vm._v(" in "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.4"
    }
  }, [_vm._v("table 1.4")]), _vm._v(" are always greater than one). As a partial remedy, we have replicated regression (3) in "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.4"
    }
  }, [_vm._v("table 1.4")]), _vm._v(", but with duration "), _c('em', [_vm._v("t")]), _vm._v(" counted from the end of the migrant’s first student spell in the United States. Results for the estimated return hazard ratios are reported in "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.7a"
    }
  }, [_vm._v("figures 1.7a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.7b"
    }
  }, [_vm._v("1.7b")]), _vm._v(", which we can compare with "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.6a"
    }
  }, [_vm._v("figures 1.6a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#fig1.6b"
    }
  }, [_vm._v("1.6b")]), _vm._v(". We notice how the estimation of return hazard ratios with respect to time now "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("changes: the inverted U-shape profile we initially observed is significantly smoothed, and the return hazard ratio appears first to increase and then to flatten down.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.6a"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0042-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.6a   Estimated hazard ratios since entry into the United States by education level: education migrants, 1990 cohort")])])]), _c('p', {
    staticClass: "tnote0"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Within-sample estimations from regression (3) in ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.4"
    }
  }, [_vm._v("table 1.4")]), _vm._v(" for age at migration = 23 and student status = 0 (all remaining regressors at mean values).")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.6b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0042-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.6b   Estimated hazard ratios since entry into the United States, by education level: education migrants, 2000 cohort")])]), _vm._v(" "), _c('p', {
    staticClass: "tnote"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Within-sample estimations from regression (3) in "), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#tab1.4"
    }
  }, [_vm._v("table 1.4")]), _vm._v(" for age at migration = 23 and student status = 0 (all remaining regressors at mean values).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overall, however, we find some signs of a positive time dependence of the return hazard on time for education migrants, which may imply positive self-selection with respect to unobservable skills. We further discuss these results in the conclusions.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.7a"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0043-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.7a   Estimated hazard ratios since completion of studies in the United States by education level: education migrants, 1990 cohort")])]), _vm._v(" "), _c('p', {
    staticClass: "tnote0"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Within-sample estimations (unreported regression) for age at migration = 23 and student status = 0 (all remaining regressors at mean values).")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1.7b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0043-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption0"
  }, [_c('strong', [_vm._v("Fig. 1.7b   Estimated hazard ratios since completion of studies in the United States by education level: education migrants, 2000 cohort")])]), _vm._v(" "), _c('p', {
    staticClass: "tnote0"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Within-sample estimations (unreported regression) for age at migration = 23 and student status = 0 (all remaining regressors at mean values).")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "ch1.5"
    }
  }, [_c('strong', [_vm._v("1.5   Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Return migration is a much understudied topic, especially when it comes to its implications for innovation in both the host and home countries. Lack of data is a major cause of this situation due to the virtual absence of official statistics and the technical difficulties that stand in the way of large-scale data mining.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("In this chapter, we have presented the outcome of an ambitious attempt to overcome such difficulties based on linking inventor information from patent data to biographical information from an important web-based social network. We focused on Indian inventors with professional experiences of various lengths at one or more US ICT companies and obtained rather reliable data for those among them who moved to the United States in the 1990s and 2000s. Based on biographical information, we could draw a clear distinction between work and education migrants and analyze separately the related return events. In particular, we applied event history analysis and explored the issue of returnees’ self-selection with respect to observable and unobservable skills.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Both the distinction between work and education migrants and the study of self-selection may contribute to evaluating the effectiveness of US migration policies, with special reference to scientists, engineers, and other innovation-relevant professional categories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As stressed by Koslowski (2018), US immigration policies are often compared unfavorably to those of countries such as Canada and Australia, whose selective, point-based visa systems are held responsible for their records of attracting high proportions of high-skilled migrants. But the comparison is biased by its exclusive focus on migrants first entering their host countries with permanent visas, which accounts for a very limited share of entries in the United States. When considering migrants entering with temporary visas, whether work- or education-based, the United States appears the most attractive country, also in view of the large share of temporary migrants turning into permanent ones over the years. In this respect, it becomes crucial to estimate the stay rates of highly skilled permanent immigrants, which our study on Indian migrants finds rather high and in accordance with the limited evidence available in the literature, especially for education migrants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides assessing the highly skilled migrants’ length of stay, it is crucial to assess whether the host countries manage to retain the best and brightest among them—namely, those who can contribute most to innovation. In this respect, Wadhwa et al. (2009) give voice to widespread concerns on the difficulties supposedly met by the United States in this respect. Our results, albeit exploratory, go against such concerns for work migrants and leave room for debate on education migrants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Concerning work migrants, Indian returnees in our sample appear to be negatively selected with respect to education as well as, most likely, to the working experience they accumulate in the United States (as inferred by the negative time dependence of their hazard ratios). Admittedly, we also find a positive relationship between the return hazard and the number of patents they produce while in the United States, but we have suggested how this may have more to do with specialization in managerial functions or entrepreneurship than with positive self-selection.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("As for education migrants, Indian returnees in our sample are also negatively ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("selected with respect to education but also appear increasingly at risk of return the longer their permanence in the United States, especially over the first 10 years after migration. This can be interpreted as positive selfselection with respect to unobservable skills, at least over the first few years after graduation. But we should bear in mind that our return migration measure does not distinguish between individuals who settle permanently back in their home countries or become engaged in circular migration patterns and/or parallel professional activities in their home and host countries.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Further research is clearly needed to both assess the strength of these initial results and extend them. Further codification of the information contained in our data set will let us assess the quality and location of the educational institutions attended by migrants so as to test whether the return hazard is positively or negatively associated with the prestige of the institution and/or its links with a vibrant labor market for the highly skilled. We also plan to fully disambiguate the name of companies reported by work migrants in their LinkedIn profiles so as to distinguish between intracompany and intercompany mobility. We expect the former to generate short-term temporary migrants, not much exposed to the risk of turning permanent, while the latter should be at the origin of longer stays and more interesting phenomena of negative versus positive self-selection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More generally, our methodology may be extended to other countries of origin of migrants besides India and to other professional categories besides those related to ICT.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("While a large amount of the knowledge we may gather on highly skilled return migration will pass through the refinement and sharing of our data, we think that some ad hoc theorizing is also necessary to adapt the emerging theoretical literature on temporary and circular migration we discussed in ")]), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#ch1.2"
    }
  }, [_vm._v("section 1.2")]), _vm._v(" to the specificities of STEM workers and students.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Allison, P. D. 2014. "), _c('em', [_vm._v("Event History and Survival Analysis: Regression for Longitudinal Event Data")]), _vm._v(". Vol. 46. Los Angeles: SAGE.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Baruffaldi, S. H., and P. Landoni. 2012. “Return Mobility and Scientific Productivity of Researchers Working Abroad: The Role of Home Country Linkages.” "), _c('em', [_vm._v("Research Policy")]), _vm._v(" 41 (9): 1655–65.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Bijwaard, G. E., C. Schluter, and J. Wahba. 2014. “The Impact of Labor Market Dynamics on the Return Migration of Immigrants.” "), _c('em', [_vm._v("Review of Economics and Statistics")]), _vm._v(" 96 (3): 483–94.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Borjas, G. J. 1989. “Immigrant and Emigrant Earnings: A Longitudinal Study.” "), _c('em', [_vm._v("Economic Inquiry")]), _vm._v(" 27 (1): 21–37.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Bönisch, P., P. Gaffert, and J. Wilde. 2013. “The Impact of Skills on Remigration Flows.” "), _c('em', [_vm._v("Applied Economics")]), _vm._v(" 45 (4): 511–24.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Borjas, G. J., and B. Bratsberg. 1996. “Who Leaves? The Outmigration of the Foreign-Born.” "), _c('em', [_vm._v("Review of Economics and Statistics")]), _vm._v(" 78 (1): 165–76.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "refentry"
  }, [_vm._v("Breschi, S., F. Lissoni, and E. Miguelez. 2017. “Foreign-Origin Inventors in the US: Testing for Diaspora and Brain Gain Effects.” "), _c('em', [_vm._v("Journal of Economic Geography")]), _vm._v(" 17 (5): 1009–38.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Choudhury, P. 2016. “Return Migration and Geography of Innovation in MNEs: A Natural Experiment of Knowledge Production by Local Workers Reporting to Return Migrants.” "), _c('em', [_vm._v("Journal of Economic Geography")]), _vm._v(" 16 (3): 585–610.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Constant, A., and D. S. Massey. 2002. “Return Migration by German Guestworkers: Neoclassical versus New Economic Theories.” "), _c('em', [_vm._v("International Migration")]), _vm._v(" 40 (4): 5–38.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Constant, A. F., O. Nottmeyer, and K. F. Zimmermann. 2013. “The Economics of Circular Migration.” In "), _c('em', [_vm._v("International Handbook on the Economics of Migration")]), _vm._v(", edited by A. F. Constant and K. F. Zimmermann, 55–74. Cheltenham: Edward Elgar.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Constant, A. F., and K. F. Zimmermann. 2016. “Diaspora Economics: New Perspectives.” "), _c('em', [_vm._v("International Journal of Manpower")]), _vm._v(" 37 (7): 1110–35.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("De Rassenfosse, G., H. Dernis, D. Guellec, L. Picci, and B. v. P. de la Potterie. 2013. “The Worldwide Count of Priority Patents: A New Indicator of Inventive Activity.” "), _c('em', [_vm._v("Research Policy")]), _vm._v(" 42 (3): 720–37.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Desai, M., D. Kapur, and J. McHale. 2005. “The Fiscal Impact of High Skilled Emigration: Flows of Indians to the US.” Mimeo, Harvard University.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Dustmann, C., I. Fadlon, and Y. Weiss, Y. 2011. “Return Migration, Human Capital Accumulation and the Brain Drain.” "), _c('em', [_vm._v("Journal of Development Economics")]), _vm._v(" 95 (1): 58–67.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Dustmann, C., and J.-S. Görlach. 2016. “The Economics of Temporary Migrations.” "), _c('em', [_vm._v("Journal of Economic Literature")]), _vm._v(" 54 (1): 98–136.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Dustmann, C., and Y. Weiss. 2007. “Return Migration: Theory and Empirical Evidence from the UK.” "), _c('em', [_vm._v("British Journal of Industrial Relations")]), _vm._v(" 45 (2): 236–56.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Filatotchev, I., X. Liu, J. Lu, and M. Wright, M. 2011. “Knowledge Spillovers through Human Mobility across National Borders: Evidence from Zhongguancun Science Park in China.” "), _c('em', [_vm._v("Research Policy")]), _vm._v(" 40 (3): 453–462.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Finn, M. G. 2014. “Stay Rates of Foreign Doctorate Recipients from US Universities, 2011.” Oak Ridge, TN: Oak Ridge Institute for Science and Education (ORISE).")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Finn, M. G., and L. A. Pennington. 2018. “Stay Rates of Foreign Doctorate Recipients from US Universities, 2013.” Oak Ridge, TN: Oak Ridge Institute for Science and Education (ORISE).")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Gaulé, P. 2014. “Who Comes Back and When? Return Migration Decisions of Academic Scientists.” "), _c('em', [_vm._v("Economics Letters")]), _vm._v(" 124 (3): 461–64.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Ge, C., K. W. Huang, and I. P. L. Png. 2016. “Engineer/Scientist Careers: Patents, Online Profiles, and Misclassification Bias.” "), _c('em', [_vm._v("Strategic Management Journal")]), _vm._v(" 37 (1): 232–53.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Gibson, J., and D. McKenzie, D. 2014. “Scientific Mobility and Knowledge Networks in High Emigration Countries: Evidence from the Pacific.” "), _c('em', [_vm._v("Research Policy")]), _vm._v(" 43 (9): 1486–95.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Hawthorne, L. 2018. “International Student Mobility: Sending Country Determinants and Policies.” In "), _c('em', [_vm._v("High-Skilled Migration: Drivers and Policies")]), _vm._v(", edited by M. Czaika, chap. 11. Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Hunt, J. 2011. “Which Immigrants Are Most Innovative and Entrepreneurial? Distinctions by Entry Visa.” "), _c('em', [_vm._v("Journal of Labor Economics")]), _vm._v(" 29:417–57.")])]), _c('p', {
    staticClass: "refentry"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Hunt, J., 2013. “Are Immigrants the Best and Brightest U.S. Engineers?” NBER ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Working Paper no. 18696. Cambridge, MA: National Bureau of Economic Research.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "refentry"
  }, [_vm._v("Jenkins, S. P. 2005. “Survival Analysis.” Unpublished manuscript, Institute for Social and Economic Research, University of Essex, Colchester, UK.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Jones, B. F. 2009. “The Burden of Knowledge and the ‘Death of the Renaissance Man’: Is Innovation Getting Harder?” "), _c('em', [_vm._v("Review of Economic Studies")]), _vm._v(" 76 (1): 283–317.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Jonkers, K., and L. Cruz-Castro. 2013. “Research upon Return: The Effect of International Mobility on Scientific Ties, Production and Impact.” "), _c('em', [_vm._v("Research Policy")]), _vm._v(" 42 (8): 1366–77.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kahn, S., and M. MacGarvie. 2016. “Do Return Requirements Increase International Knowledge Diffusion? Evidence from the Fulbright Program.” "), _c('em', [_vm._v("Research Policy")]), _vm._v(" 45 (6): 1304–22.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kapur, D. 2010. “Indian Higher Education.” In "), _c('em', [_vm._v("American Universities in a Global Market")]), _vm._v(", edited by C. T. Clotfelter, 305–34. Chicago: University of Chicago Press.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kapur, D., and J. McHale. 2005. "), _c('em', [_vm._v("Give Us Your Best and Brightest: The Global Hunt for Talent and Its Impact on the Developing World")]), _vm._v(". Washington, DC: Center for Global Development.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kerr, W. R. 2017. “US High-Skilled Immigration, Innovation, and Entrepreneurship: Empirical Approaches and Evidence.” In "), _c('em', [_vm._v("The International Mobility of Talent and Innovation: New Evidence and Policy Implications")]), _vm._v(", edited by C. Fink and E. Miguelez, 193–221. Cambridge: Cambridge University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kerr, S. P., W. R. Kerr, and W. F. Lincoln. 2015. “Skilled Immigration and the Employment Structures of US Firms.” "), _c('em', [_vm._v("Journal of Labor Economics")]), _vm._v(" 33 (S1): S147–S186.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kerr, W. R., and W. F. Lincoln. 2010. “The Supply Side of Innovation: H-1B Visa Reforms and U.S. Ethnic Invention.” "), _c('em', [_vm._v("Journal of Labor Economics")]), _vm._v(" 28 (3): 473–508.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Kirdar, M. G. 2009. “Labor Market Outcomes, Savings Accumulation, and Return Migration.” "), _c('em', [_vm._v("Labour Economics")]), _vm._v(" 16 (4): 418–28.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Koslowski, R. 2018. “Shifts in Selective Migration Policy Models.” In "), _c('em', [_vm._v("High-Skilled Migration: Drivers and Policies")]), _vm._v(", edited by M. Czaika, chap. 6. Oxford: Oxford University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Lowell, B. L. 2000. “H-1B Temporary Workers: Estimating the Population.” UC San Diego Working Papers. Working Paper no. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Luo, S., M. E. Lovely, and D. Popp. 2013. “Intellectual Returnees as Drivers of Indigenous Innovation: Evidence from the Chinese Photovoltaic Industry.” NBER Working Paper no. 19518. Cambridge, MA: National Bureau of Economic Research.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Nanda, R., and T. Khanna. 2010. “Diasporas and Domestic Entrepreneurs: Evidence from the Indian Software Industry.” "), _c('em', [_vm._v("Journal of Economics and Management Strategy")]), _vm._v(" 19 (4): 991–1012.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("OECD. 2008. "), _c('em', [_vm._v("International Migration Outlook")]), _vm._v(". Paris: Organisation for Economic Co-operation and Development.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("OECD. 2017. "), _c('em', [_vm._v("International Migration Outlook")]), _vm._v(". Paris: Organisation for Economic Co-operation and Development.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Oettl, A., and A. Agrawal. 2008. “International Labor Mobility and Knowledge Flow Externalities.” "), _c('em', [_vm._v("Journal of International Business Studies")]), _vm._v(" 39 (8): 1242–60.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Teitelbaum, M. S. 2014. "), _c('em', [_vm._v("Falling Behind? Boom, Bust, and the Global Race for Scientific Talent")]), _vm._v(". Princeton, NJ: Princeton University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Trippl, M. 2013. “Scientific Mobility and Knowledge Transfer at the Interregional and Intraregional Level.” "), _c('em', [_vm._v("Regional Studies")]), _vm._v(" 47 (10), 1653–67.")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("UN. 1998. "), _c('em', [_vm._v("Recommendations on Statistics of International Migration, Revision 1")]), _vm._v(". New York: United Nations Statistics Division.")])]), _c('p', {
    staticClass: "refentry"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Wadhwa, V. 2009. “A Reverse Brain Drain.” "), _c('em', [_vm._v("Issues in Science and Technology")]), _vm._v(" 25 (3): 45–52.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('p', {
    staticClass: "refentry"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Wadhwa, V., A. Saxenian, R. B. Freeman, and A. Salkever. 2009. “Losing the World’s Best and Brightest: America’s New Immigrant Entrepreneurs, Part 5.” Mimeo. ")]), _c('a', {
    attrs: {
      "href": "http://ssrn.com/abstract=1362012",
      "target": "_blank"
    }
  }, [_vm._v("http://ssrn.com/abstract=1362012")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "refentry"
  }, [_vm._v("Zagheni, E., and I. Weber. 2015. “Demographic Research with Non-representative Internet Data.” "), _c('em', [_vm._v("International Journal of Manpower")]), _vm._v(" 36 (1): 13–25.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd41e0ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226695761_10_ch1.vue
// module id = 84
// module chunks = 0